import React from 'react';
import BlogPostCard from './BlogPostCard';
import { blogPosts } from './blogPostsData';

const BlogPosts: React.FC = () => {
  return (
    <section className="bg-[#F3F4F6] py-16 md:py-20">
      <div className="mx-auto px-4 md:px-10 lg:px-32 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <BlogPostCard
              key={post.id}
              image={post.image}
              title={post.title}
              description={post.description}
              author={post.author}
              authorImage={post.authorImage}
              date={post.date}
              link={post.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPosts;

